/* VYREN STUDIO — scripts propios */
(function () {
  function initBurger(root) {
    (root || document).querySelectorAll('[data-mt-header]').forEach(function (header) {
      var btn = header.querySelector('[data-mt-burger]');
      if (!btn || btn.dataset.mtBound) return;
      btn.dataset.mtBound = '1';
      btn.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      header.querySelectorAll('.mt-header__nav a').forEach(function (a) {
        a.addEventListener('click', function () {
          header.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  var observer = null;
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    items.forEach(function (el) { observer.observe(el); });
  }

  function init(root) { initBurger(root); initReveal(root); }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  // Editor de temas de Shopify: al recargar una sección, reactivar efectos
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
